import { useEffect, useState } from "react";
import "./Users.scss";
import { getAnalyticsOverviewAPI } from "../api/ClientApi";
import { useDispatch } from "react-redux";
import { handleLogoutRedux } from "../../redux/actions/userAction";
import { toast } from "react-toastify";
import { AppsIcon, DevicesIcon, CheckCircleIcon, BellIcon } from "../icons";

const Users = (props) => {
  const [users, setUsers] = useState({ total: 0, last7Days: 0, byApp: [] });
  const [tokens, setTokens] = useState({ total: 0, alive: 0, byApp: [] });
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    getAnalyticsOverviewAPI().then((response) => {
      setLoading(false);
      const { errorCode, message, data } = response;
      if (errorCode === 0) {
        setUsers(data.users);
        setTokens(data.tokens);
      } else if (errorCode === 401) {
        dispatch(handleLogoutRedux());
      } else {
        toast.error(message);
      }
    });
  }, []);

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Analytics</h1>
          <p className="page-subtitle">Thống kê người dùng cuối và push token trên toàn hệ thống.</p>
        </div>
      </div>

      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-card-icon">
            <AppsIcon />
          </div>
          <div>
            <div className="stat-card-value">{users.total}</div>
            <div className="stat-card-label">Tổng user</div>
          </div>
        </div>
        <div className="stat-card stat-card--info">
          <div className="stat-card-icon">
            <BellIcon />
          </div>
          <div>
            <div className="stat-card-value">{users.last7Days}</div>
            <div className="stat-card-label">User mới 7 ngày qua</div>
          </div>
        </div>
        <div className="stat-card stat-card--warning">
          <div className="stat-card-icon">
            <DevicesIcon />
          </div>
          <div>
            <div className="stat-card-value">{tokens.total}</div>
            <div className="stat-card-label">Tổng token</div>
          </div>
        </div>
        <div className="stat-card stat-card--success">
          <div className="stat-card-icon">
            <CheckCircleIcon />
          </div>
          <div>
            <div className="stat-card-value">{tokens.alive}</div>
            <div className="stat-card-label">Token đang hoạt động</div>
          </div>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-white fw-semibold">User theo app</div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead>
                  <tr>
                    <th scope="col">App</th>
                    <th scope="col">App ID</th>
                    <th scope="col" className="text-end">
                      Số user
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {users.byApp.map((item, index) => (
                    <tr key={index}>
                      <td>{item.app_name}</td>
                      <td className="text-muted small">{item.app_id}</td>
                      <td className="text-end fw-semibold">{item.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {!loading && users.byApp.length === 0 && (
              <div className="empty-state">Chưa có user nào.</div>
            )}
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-white fw-semibold">Token theo app</div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead>
                  <tr>
                    <th scope="col">App</th>
                    <th scope="col">Platform</th>
                    <th scope="col">Alive / Total</th>
                  </tr>
                </thead>
                <tbody>
                  {tokens.byApp.map((item, index) => {
                    const percent = item.total > 0 ? Math.round((item.alive / item.total) * 100) : 0;
                    return (
                      <tr key={index}>
                        <td>{item.app_name}</td>
                        <td>
                          <span
                            className={`badge rounded-pill text-bg-${
                              item.platform === "ios" ? "info" : "warning"
                            }`}
                          >
                            {item.platform}
                          </span>
                        </td>
                        <td style={{ minWidth: 160 }}>
                          <div className="d-flex align-items-center gap-2">
                            <div className="progress flex-fill" style={{ height: 6 }}>
                              <div
                                className="progress-bar bg-success"
                                role="progressbar"
                                style={{ width: `${percent}%` }}
                              />
                            </div>
                            <span className="small text-muted flex-shrink-0">
                              {item.alive}/{item.total}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {!loading && tokens.byApp.length === 0 && (
              <div className="empty-state">Chưa có token nào được đăng ký.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Users;
